import Phaser from 'phaser';
import componentCoordinates from './ComponentCoordinates';
import DailyBonusSprite from '../classes/DailyBonusSprite';
import BonezButton from '../classes/BonezButton';
import { session, client } from '../../../../utils/nakama';
import eventsCenter, { PHASER_EVENTS } from '../../../../utils/phaserEvents';

let scale;
let coordinates;
let screenWidth = window.outerWidth; // 3840 is for 16:9 ,  2532 (scaled to 3840) is for 19.5:9
let screenHeight = window.outerHeight; // 2160 is for 16:9 ,  1170 (scaled to 1774) is for 19.5:9


export default class DailyBonus extends Phaser.Scene {
    constructor() {
        super("DailyBonus");
    }

    init(data) {
        this.DailyRewardStatus = data.dailyRewardStatus;
    }

    preload() {
        if (screenWidth >= 1200) {
            scale = componentCoordinates.desktop.scale;
            coordinates = componentCoordinates.desktop.coordinates;
        }else{
            scale = componentCoordinates.mobile.scale;
            coordinates = componentCoordinates.mobile.coordinates;
        }

        // preload the audio file that is needed
        //console.log("DailyBonusStatus: ", this.DailyRewardStatus);
        if(this.DailyRewardStatus.dailyCounter === 1){
            this.load.audio('win-day-sound', '/bonez/sounds/win-day1.mp3');
        }else if(this.DailyRewardStatus.dailyCounter === 2){
            this.load.audio('win-day-sound', '/bonez/sounds/winbanjo.mp3');
        }else if(this.DailyRewardStatus.dailyCounter === 3){
            this.load.audio('win-day-sound', '/bonez/sounds/winbrass.mp3');
        }else if(this.DailyRewardStatus.dailyCounter === 4){
            this.load.audio('win-day-sound', '/bonez/sounds/windoot.mp3');
        }else if(this.DailyRewardStatus.dailyCounter === 5){
            this.load.audio('win-day-sound', '/bonez/sounds/winfantasia.mp3');
        }
    }
    
    create() {
        this.cameras.main.fadeIn(500, 0, 0, 0);

        //add background
        this.add.image(0, 0, 'bonus_images',"daily_bonus_bg").setOrigin(0, 0).setScale(scale.DailyBonusBg);

        //Add particles behind the bag
        this.particles = this.add.particles(coordinates.other.particlesXP.x, coordinates.other.particlesXP.y,'xp',{
            scale: { start: 0.2, end: 0, random: true },
            rotate: { start: 0, end: 360 },
            speed: 200,
            lifespan: scale.particlesXPLifeSpan,
            gravityY: 0,
        });
        
        //add text 
        this.add.text(coordinates.text.returnEveryDay.x, coordinates.text.returnEveryDay.y, 'Return every day',
            {
                font: '900 120px Truculenta',
                color: '#A7E73C'
            }
        ).setScale(scale.returnEveryDay);
        this.add.text(coordinates.text.forNewRewards.x, coordinates.text.forNewRewards.y, 'for new Rewards!',
            {
                font: '900 120px Truculenta',
                color: '#A7E73C'
            }
        ).setScale(scale.returnEveryDay);

        this.day1 = new DailyBonusSprite(
            this,
            coordinates.other.day1BonusSprite.x, // x position
            coordinates.other.day1BonusSprite.y, // y position
            "day1", // Texture for the main image
            scale.day1BonusSprite, // Image scale
        );

        this.day2 = new DailyBonusSprite(
            this,
            coordinates.other.day1BonusSprite.x + scale.bonusSpriteOffset, // x position
            coordinates.other.day1BonusSprite.y, // y position
            "day2", // Texture for the main image
            scale.bonusSprite, // Image scale
        );

        this.day3 = new DailyBonusSprite(
            this,
            coordinates.other.day1BonusSprite.x + (2*scale.bonusSpriteOffset) + 40 , // x position
            coordinates.other.day1BonusSprite.y, // y position
            "day3", // Texture for the main image
            scale.bonusSprite, // Image scale
        );

        this.day4 = new DailyBonusSprite(
            this,
            coordinates.other.day1BonusSprite.x + (3*scale.bonusSpriteOffset) + 110, // x position
            coordinates.other.day1BonusSprite.y, // y position
            "day4", // Texture for the main image
            scale.bonusSprite, // Image scale
        );

        this.day5 = new DailyBonusSprite(
            this,
            coordinates.other.day1BonusSprite.x + (4*scale.bonusSpriteOffset) + 140, // x position
            coordinates.other.day1BonusSprite.y, // y position
            "day5", // Texture for the main image
            scale.bonusSprite, // Image scale
        );

        this.tweens.add({
            targets: this.day5,
            angle: { from: -10, to: 10 },
            duration: 300,
            ease: 'Sine.easeInOut',
            yoyo: true,
            repeat: -1,
            repeatDelay: 5000,
        });

        //Add sprites to a container
        this.dayRewards = this.add.container(10, 10);
        this.dayRewards.add([this.day1, this.day2, this.day3, this.day4, this.day5]);
        for (let i = 0; i < this.DailyRewardStatus.dailyCounter - 1; i++) {
            this.dayRewards.list[i].showCheckMark();
        }

        //Add Reward labels under the sprites in a container
        this.dayLabels = this.add.container(10, 30);
        this.drawRewardLabels();

        // Add button at the bottom center
        this.btnCollectReward = new BonezButton(this, coordinates.other.openBagButton.x, coordinates.other.openBagButton.y, 'COLLECT REWARD', () => {
            //call the collect reward function
            this.collectReward();
        }).setScale(scale.openBagButton);

        //Determines if the button should be visible or not
        if (this.DailyRewardStatus.serverTime >= this.DailyRewardStatus.nextReward) {
            this.btnCollectReward.show();
        } else {
            this.btnCollectReward.setVisible(false);
            this.startDayTimer();
        }
    }


    // Function to determine the color based on the day
    getColorForDay = (dayNumber, currentDay) => {
        return dayNumber < currentDay ? '#00D1FF' //blue
            : dayNumber > currentDay ? '#5A4F71'  //grey
            : '#A7E73C';      //green
    };

    drawRewardLabels = () => {
        const rewardLabels = ['5 BONEZ', '10 BONEZ', '15 BONEZ', '20 BONEZ', 'SURPRISE BAG!']; 
        for (let day = 1; day <= 5; day++) {
            let dayXPosition = coordinates.text.dailyRewardDayLabel.x + ((day-1) * scale.bonusSpriteOffset);
            if(day === 4) { //day 4
                dayXPosition += 40;
            }
            if(day === 5) { //day 5
                dayXPosition += 80;
            }
            let dayText = 
                day < this.DailyRewardStatus.dailyCounter ? rewardLabels[day-1] 
                : day === this.DailyRewardStatus.dailyCounter ? 'TODAY'
                : `DAY ${day}`;
            
            if (day === 5) {
                dayText = day === this.DailyRewardStatus.dailyCounter-1 ? 'TODAY' : 'DAY 5+';
                this.dayLabels.add(this.add.text(dayXPosition, coordinates.text.dailyRewardDayLabel.y + 100, 'SURPRISE BAG!', { font: '900 110px Truculenta', color: this.getColorForDay(day, this.DailyRewardStatus.dailyCounter) }).setOrigin(0.5, 0.5).setScale(scale.dailyRewardDayLabel));
            }

            this.dayLabels.add(this.add.text(dayXPosition, coordinates.text.dailyRewardDayLabel.y, dayText, { font: '900 120px Truculenta', color: this.getColorForDay(day, this.DailyRewardStatus.dailyCounter) }).setOrigin(0.5, 0.5).setScale(scale.dailyRewardDayLabel))
        }
    }


    startDayTimer() {
        // Start a 24-hour timer
        //let duration = 86400000; // 24 hours in milliseconds
        let duration = this.DailyRewardStatus.nextReward - this.DailyRewardStatus.serverTime; // 24 hours in milliseconds
        let endTime = this.DailyRewardStatus.serverTime + duration;
    
        this.time.addEvent({
            delay: 1000,
            callback: () => {
                let remaining = endTime - Date.now();
                if (remaining < 0) {
                    // When the timer ends, show the button again
                    this.time.removeAllEvents();
                    this.btnCollectReward.show();
                    if (this.timerText) {
                        this.nextRewardText.setVisible(false);
                        this.timerText.setVisible(false);
                    }
                } else {
                    // Update the timer text
                    if (!this.timerText) {
                        // Text for "NEXT REWARD IN:" initially hidden
                        this.nextRewardText = this.add.text(coordinates.text.nextRewardIn.x, coordinates.text.nextRewardCounter.y, 'NEXT REWARD IN:', {
                            font: '900 100px Truculenta',
                            color: 'white',
                        });
                        this.timerText = this.add.text(coordinates.text.nextRewardCounter.x, coordinates.text.nextRewardCounter.y, '', {
                            font: '900 100px Truculenta',
                            color: '#A7E73C'
                        });
                    } else if (!this.timerText.visible) {
                        this.nextRewardText.setVisible(true);
                        this.timerText.setVisible(true);
                    }
                    this.timerText.setText(this.formatTime(remaining));
                }
            },
            callbackScope: this,
            loop: true
        });
    }
    
    formatTime(milliseconds) {
        let seconds = Math.floor((milliseconds / 1000) % 60);
        let minutes = Math.floor((milliseconds / (1000 * 60)) % 60);
        let hours = Math.floor((milliseconds / (1000 * 60 * 60)) % 24);
    
        hours = (hours < 10) ? "0" + hours : hours;
        minutes = (minutes < 10) ? "0" + minutes : minutes;
        seconds = (seconds < 10) ? "0" + seconds : seconds;
    
        return hours + ":" + minutes + ":" + seconds;
    }

    showBonezAnimation() {
        //Add Bonez animation
        let bone = this.add.sprite(coordinates.other.openBagButton.x, coordinates.other.openBagButton.y, 'bone').setScale(1);
        this.tweens.add({
            targets: bone, 
            angle: 360,
            x: Math.random() * 400,
            y: Math.random() * 400,
            scale: Math.random() * 0.3,
            duration: (Math.random() * 500) + 200,
            ease: 'Linear',
            repeat: 0,
            onComplete: () => {
                bone.destroy();
            }
        });
    }

    async collectReward() {
        //call the collect reward function
        this.btnCollectReward.setVisible(false);
        //TODO - Show spinner
        // Call RPC to collect reward    
        const res = await client.rpc(session, "checkdailyreward", {"request": "collectReward"});
        this.DailyRewardStatus = res.payload;
        this.startDayTimer();
        //show the check mark for claimed rewards
        this.dayRewards.list[this.DailyRewardStatus.dailyCounter - 2].showCheckMark();
        //clear and redraw the labels
        this.dayLabels.removeAll(true);
        this.drawRewardLabels();
        eventsCenter.emit(PHASER_EVENTS.REWARD_COLLECTED, this.DailyRewardStatus);
        //TODO - Play collect sound and show animation
        // this.sound.play('win-day' + this.DailyRewardStatus.dailyCounter);
        this.sound.play('win-day-sound');
        //Show Bonez animation
        for(let i = 0; i < (this.DailyRewardStatus.dailyCounter*5); i++){
            this.showBonezAnimation();
        }
    }
}
